import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import FeaturedTable from '../../FeaturedTable/FeaturedTable'
import Icon from '../../Icons'
import { selectStaffPersons } from '../../../reducers/maintenanceStaffReducer'

const MaintenanceStaffList = ({ isLoading, onSelectStaffMember }) => {
  const { t } = useTranslation(['maintenance'])
  const staffPersons = useSelector(selectStaffPersons)
  const params = useParams()

  const columns = [
    {
      Header: t('maintenance:staff.columns.name'),
      id: 'name',
      Cell: (data) => {
        const { row } = data
        return row.original.user
          ? `${row.original.user.firstName} ${row.original.user.lastName}`
          : ''
      },
    },
    {
      Header: t('maintenance:staff.columns.phone'),
      accessor: 'phone',
      id: 'phone',
    },
    {
      Header: t('maintenance:staff.columns.email'),
      id: 'email',
      Cell: (data) => {
        const { row } = data
        return row.original.user ? row.original.user.email : ''
      },
    },
    {
      id: 'arrow',
      Header: () => null,
      Cell: (data) => {
        const { row } = data
        return (
          <div
            className={`ctp-maintenance-staff-list__arrow`}
            onClick={() => onSelectStaffMember(row.original)}
          >
            <Icon icon={'arrow'} />
          </div>
        )
      },
    },
  ]

  return (
    <div
      className={`ctp-maintenance-staff-list ctp-guests-residents-list ${
        isLoading && 'is-loading'
      }`}
    >
      {!isLoading && params.buildingId && staffPersons.length ? (
        <FeaturedTable
          columns={columns}
          onRowClick={(row) => onSelectStaffMember(row.original)}
          data={staffPersons}
        />
      ) : (
        !isLoading &&
        !staffPersons.length && (
          <p className="has-text-centered">
            {params.buildingId
              ? t('maintenance:staff.list.noStaffYet')
              : t('maintenance:staff.list.selectBuilding')}
          </p>
        )
      )}
    </div>
  )
}

MaintenanceStaffList.propTypes = {
  isLoading: PropTypes.bool,
  onSelectStaffMember: PropTypes.func,
}

export default MaintenanceStaffList
